/**
 * A count with its noun, in the singular for one: `plural(1, 'image')` is "1 image", `plural(3, 'image')` is
 * "3 images". For nouns that pluralize with an "s" only.
 */
function plural(count: number, noun: string): string {
  return `${count} ${count === 1 ? noun : `${noun}s`}`;
}

export { plural };
